import { Badge, Card, SectionLabel } from '@wundo/ui';
import type { DirectorDecision } from '@/types/messages.ts';

export interface DirectorDecisionNoteProps {
  decision: DirectorDecision;
}

/**
 * What the director of a spoken practice made of the answer above it. Never
 * part of the conversation itself, so drawn across the width like a tool call.
 */
export function DirectorDecisionNote({ decision }: DirectorDecisionNoteProps) {
  const flagged = decision.wrap_up || decision.end_call || decision.ignored;

  return (
    <Card tone='quiet' padding='none' className='flex flex-col gap-1.5 p-3.5'>
      <SectionLabel as='h3'>Director</SectionLabel>

      {decision.note ? (
        <p className='text-sm whitespace-pre-wrap text-ink-body'>{decision.note}</p>
      ) : null}

      {flagged ? (
        <div className='flex flex-wrap gap-1'>
          {decision.wrap_up && <Badge tone='info'>Wrap up</Badge>}
          {decision.end_call && <Badge tone='warning'>End call</Badge>}
          {decision.ignored && <Badge tone='quiet'>Ignored: {decision.ignored}</Badge>}
        </div>
      ) : null}

      {decision.reason ? (
        <p className='text-xs whitespace-pre-wrap text-ink-muted'>{decision.reason}</p>
      ) : null}
    </Card>
  );
}
